module.exports = __webpack_public_path__ + "static/img/PleaseSelect.7001476.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon/PleaseSelect.svg
// module id = zWdo
// module chunks = 2